import { loadable } from '../../components/loadable';
import { Spinner } from '../../components/Spinner/Spinner';

export const LoadableWasabiPage = loadable(() => import('./WasabiPage'), {
  key: 'HotWasabiPage',
  loading: Spinner,
});
